require('bootstrap');
require('angular');
require('jquery.easing');

module.exports = angular.module('ThemeFunctions', [])
    .directive('themeFunctions', function () {
        return {
            controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
                // jQuery for page scrolling feature - requires jQuery Easing plugin
               jQuery('a.page-scroll').bind('click', function (event) {
                    var $anchor = jQuery(this);
                    jQuery('html, body').stop().animate({
                        scrollTop: (jQuery($anchor.attr('href')).offset().top - 50)
                    }, 1250, 'easeInOutExpo');
                    event.preventDefault();
                });

                // Highlight the top nav as scrolling occurs
                jQuery('body').scrollspy({
                    target: '.navbar-fixed-top',
                    offset: 51
                });

                // Closes the Responsive Menu on Menu Item Click
                jQuery('.navbar-collapse ul li a').click(function () {
                    jQuery('.navbar-toggle:visible').click();
                });

                // Offset for Main Navigation
                jQuery('#mainNav').affix({
                    offset: {
                        top: 100
                    }
                })

                var fixed = false;
                jQuery(document).scroll(function () {
                    if (jQuery(this).scrollTop() > 250) {
                        if (!fixed) {
                            fixed = true;
                            // jQuery('#to-top').css({position:'fixed', display:'block'});
                            jQuery('#to-top').show("slow", function () {
                                jQuery('#to-top').css({
                                    position: 'fixed',
                                    display: 'block'
                                });
                            });
                        }
                    } else {
                        if (fixed) {
                            fixed = false;
                            jQuery('#to-top').hide("slow", function () {
                                jQuery('#to-top').css({
                                    display: 'none'
                                });
                            });
                        }
                    }
                });

                //fix body extra right padding on multiple modals
                jQuery('.modal').on('hide.bs.modal', function (e) {
                    e.stopPropagation();
                    jQuery('body').css('padding-right', '');
                });

                jQuery('.wn-tooltip').tooltip();
            }]
        }
    });


//////////////////
// WEBPACK FOOTER
// ./jssrc/ThemeFunctions.js
// module id = 3
// module chunks = 2